import { Routes } from '@angular/router';
import { validSessionGuard } from './auth-session.guard';
import { Login } from './pages/login/login';
import { Home } from './pages/home/home';
import { Destination } from './pages/destination/destination';
import { Agenda } from './pages/agenda/agenda';
import { Attire } from './pages/attire/attire';
import { Activities } from './pages/activities/activities';
import { Dining } from './pages/dining/dining';
import { TravelGuide } from './pages/travel-guide/travel-guide';
import { Faqs } from './pages/faqs/faqs';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: Login, title:'Login' },
  { path: 'home', component: Home, title:'Home', canActivate: [validSessionGuard] },
  { path: 'destination', component: Destination, title:'Destination', canActivate: [validSessionGuard] },
  { path: 'agenda', component: Agenda, title:'Agenda', canActivate: [validSessionGuard] },
  { path: 'attire', component: Attire, title:'Attire', canActivate: [validSessionGuard] },
  { path: 'activities', component: Activities, title:'Activities', canActivate: [validSessionGuard] },
  { path: 'dining', component: Dining, title:'Dining', canActivate: [validSessionGuard] },
  { path: 'travelGuide', component: TravelGuide, title:'TravelGuide', canActivate: [validSessionGuard] },
  { path: 'faqs', component: Faqs, title:'FAQs', canActivate: [validSessionGuard] }
];

